<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="750px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    Tworzenie zawieszki z kampanii
                </h1>
            </v-card-title>

            <v-card-text class="text-center">
                <v-container fluid class="pa-0">
                    <v-row>
                        <v-col cols="12" md="4" class="pt-4">
                            <h2 class="text-h6 font-weight-regular">
                                Zamknięte kampanie
                            </h2>
                        </v-col>
                        <v-col cols="12" md="8" class="px-12">
                            <v-text-field
                                v-model="filters.number"
                                append-icon="mdi-magnify"
                                label="Numer kampanii"
                                single-line
                                clearable
                                solo
                                dense
                                hide-details
                                @keyup.enter="changeFilter()"
                                @click:append="changeFilter()"
                                @click:clear="clearFilter('number')"
                            />
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col cols="12">
                            <v-data-table
                                name="listData"
                                :headers="headers"
                                :items="campaigns"
                                :mobile-breakpoint="0"
                                :footer-props="footerProps"
                                :server-items-length="pagination.itemsLength"
                                :page.sync="pagination.page"
                                :items-per-page.sync="pagination.itemsPerPage"
                                @pagination="updatePagination"
                            >
                                <template #item.name="{item}">
                                    {{ item.name }}
                                </template>
                                <template #item.actions="{item}">
                                    <div class="d-inline-flex">
                                        <v-tooltip :open-delay="tooltipDelay" top>
                                            <template #activator="{on}">
                                                <v-btn
                                                    icon
                                                    data-sentry-label="Otwórz"
                                                    :disabled="!item.canCreateShippingLabel"
                                                    v-on="on"
                                                    @click="createLShipmentLabel(item.id)"
                                                >
                                                    <v-icon color="teal">
                                                        mdi-exit-to-app
                                                    </v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Utwórz</span>
                                        </v-tooltip>
                                    </div>
                                </template>
                            </v-data-table>
                        </v-col>
                    </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Zamknij"
                    :disabled="actionLoading"
                    @click="onClose"
                >
                    Zamknij
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { errorHandler } from '@/utils/errorHandler'
import tooltipDelay from '@/mixins/tooltip'
import pagination from '@/mixins/dataTablePagination'
import filters from '@/mixins/dataTableFilters'

export default {
    name: 'CampaignShippingLabelDialog',
    mixins: [ 
        tooltipDelay,
        filters,
        pagination,
    ],
    props: {
        isOpen: {
            type: Boolean
        },
        actionLoading: {
            type: Boolean
        },
    },
    data() {
        return {
            campaigns: [],
            headers: [
                {
                    text: 'Numer kampanii',
                    align: 'center',
                    sortable: true,
                    value: 'number'
                },
                {
                    text: 'Akcje',
                    align: 'center',
                    sortable: false,
                    value: 'actions'
                }
            ],
        }
    },
    computed: {
        filterQuery() {
            const filters = this.filters
            let query = ''

            for (let item in filters) {
                if (filters[item] != null && filters[item] !== '') {
                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
        footerProps() {
            return {
                itemsPerPageOptions: [5, 10, 15],
            }
        }
    },
    watch: {
        isOpen(value) {
            if (value && !this.campaigns.length) {
                this.getClosedCampaigns()
            }
        }
    },
    mounted() {
        this.setDefaultPagination()
    },
    methods: {
        getClosedCampaigns() {
            this.filters.canCreateShippingLabel = true
            this.getCampaigns(() => {
                delete this.filters.canCreateShippingLabel
            })
        },
        getCampaigns(callback = () => {}) {
            this.$store.dispatch('campaigns/campaignsForShippingLabel', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then((response) => {
                    this.handlePaginationResponse(response)
                    this.campaigns = response.data.results
                    callback()
                })
                .catch(error => errorHandler(error))
        },
        createLShipmentLabel(campaignId) {
            this.$store.dispatch('shipments/shipmentsLabels/createShippingLabelFromCampaign', { campaignId })
                .then(() => {
                    this.onClose()
                })
                .catch(error => errorHandler(error))
        },
        changeFilter() {
            this.getCampaigns()
        },
        updatePagination(pagination) {
            this.pagination = pagination
            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending) {
                this.getCampaigns()
            }
            this.clearPaginationPending()
        },
        setDefaultPagination() {
            this.resetPagination()
            this.pagination.itemsPerPage = this.footerProps.itemsPerPageOptions[0]
        },
        onClose() {
            setTimeout(() => {
                this.campaigns = []
                this.filters.number = ''
                this.setDefaultPagination()
            }, 300)
            this.$emit('on-close')
        }
    }
}
</script>